import { createSlice } from "@reduxjs/toolkit";

const commonSlice = createSlice({
  name: "user",
  initialState: {
    data: {
      role_id: null,
      uuid: "",
      admin_uuid: "",
    },
    reloadManagerList: false,
    propertiesCount: undefined as number | undefined,
  },

  reducers: {
    setUserData(state: any, action: any) {
      state.data = action.payload;
    },
    setReloadManagerList(state: any, { payload }) {
      state.reloadManagerList = payload;
    },
    setPropertiesCount(state: any, { payload }) {
      state.propertiesCount = payload;
    },
  },
});
export const { setUserData, setReloadManagerList, setPropertiesCount } = commonSlice.actions;
export default commonSlice.reducer;
